import React, { useEffect, useState } from 'react'
import {
  ManageAccountsOutlined,
  EditOutlined,
  LocationOnOutlined,
  WorkOutlineOutlined,
} from "@mui/icons-material";
import {useSelector} from "react-redux"
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useNavigate} from 'react-router-dom';

const UserWidgets = ({userId,picturePath}) => {
    const [user,setUser]=useState(null)

    const {token}=useSelector((state)=>state.app)
    const friendsArray=useSelector((state)=>state.app.user.friends)
    const navigate=useNavigate()

    //getUser will fetch user from db by using id
    const getUser=async()=>{
        const response=await fetch(`https://thoughtful-erin-oyster.cyclic.app/users/${userId}`,{
            method:"GET",
            headers:{
                'authorization':`Bearer ${token}`,
            }
        })
        const data= await response.json()
        setUser(data)

    }

    //whenever this component mount and userId changes this useEffect will execute
    useEffect(()=>{
        getUser()
    },[userId])// eslint-disable-line react-hooks/exhaustive-deps

    if(!user){
        return null
    }

    const {firstName,location,occupation,viewedProfile,impressions,}=user
  return (
    <div className='bg-white dark:bg-gray-900 rounded-md divide-y divide-gray-200 p-4 flex flex-col gap-3 h-fit sticky top-8 '>
        {/* row1  */}
        <div className='w-full flex items-center gap-3 cursor-pointer' onClick={()=>navigate(`/profile/${userId}`)} >
            <div className='w-[35px] h-[35px]'>
                <img className='w-full h-full object-cover rounded-full ' src={`${picturePath}`} alt="" />
            </div>
            <div className='flex min-w-fit justify-center items-center flex-col'>
                <h2 className=' text-gray-600 dark:text-gray-200 font-medium text-sm capitalize'>{firstName}</h2>
                <p className='text-xs text-gray-400'>{friendsArray.length} friends</p>
            </div>
            <div className='text-rose-600'>
                <ManageAccountsOutlined className='svg-size'/>
            </div>
        </div>
        {/* row2 */}
        <div className='w-full flex flex-col gap-[0.3rem] '>
            <div className="w-full flex gap-1 items-center mt-1">
                <div className='text-rose-600'>
                    <LocationOnOutlined className='svg-size' />
                </div>
                <h3 className='text-xs w-full text-gray-400 capitalize' >{location}</h3>
            </div>
            <div className="flex gap-1 w-full items-center">
                <div className='text-rose-600'>
                    <WorkOutlineOutlined className='svg-size'/>
                </div>
                <h3 className='w-full text-xs text-gray-400 capitalize'>{occupation}</h3>
            </div>
        </div>
        {/* row3 */}
        <div className='w-full flex flex-col gap-2'>
            <div className=" w-full flex gap-1 items-center justify-between mt-1">
                <h3 className='text-xs text-gray-400'>Who viewed your profile</h3>
                <h3 className='text-xs text-gray-500' >{viewedProfile}</h3>
            </div>
            <div className="w-full flex gap-1 items-center justify-between">
                <h3 className='text-xs text-gray-400'>Impressions of your post</h3>
                <h3 className='text-xs text-gray-500'>{impressions}</h3>
            </div>
        </div>
        {/* row4 */}
        <div className="w-full flex flex-col gap-2" >
            <h3 className='w-full mt-1 text-xs text-gray-500 font-semibold'>Social Profiles</h3>
            <div className='w-full flex justify-between items-center'>
                <div className='w-full flex gap-1 items-center'>
                    <TwitterIcon className='text-xs text-rose-600'/>
                    <div className='w-full flex flex-col'>
                    <h3 className='w-full text-xs font-medium text-gray-500'>Twitter</h3>
                    <h3 className='w-full text-xs text-gray-400'>Social Network</h3>
                </div>
                </div>
                <div >
                    <EditOutlined className='svg-size text-rose-600'/>
                </div>
            </div>
            <div className='w-full flex justify-between items-center'>
                <div className='w-full flex gap-1 items-center'>
                    <LinkedInIcon className='text-xs text-rose-600'/>
                    <div className='w-full flex flex-col'>
                    <h3 className='w-full text-xs font-medium text-gray-500'>Linkedin</h3>
                    <h3 className='w-full text-xs text-gray-400'>Network Platform</h3>
                    </div>     
                </div>
                <div>
                    <EditOutlined className='svg-size text-rose-600'/>  
                </div>
            </div>
        </div>
    </div>
  )
}

export default UserWidgets